import { ApolloError, ServerParseError } from "@apollo/client";
import { GraphQLErrors } from "@apollo/client/errors";
import { ServerError } from "@apollo/client/link/utils";
import { GraphQLError } from "graphql";
import { ApiErrorTypes } from "~/Redux/Actions";
import { GraphQLErrors as GraphQLErrorTypes } from "./clients";

export class GraphQLServerError extends Error {
    code: string;
    errorType?: string;
    entityName?: string;
    objectKey?: number;
    errorKey?: string;
    isUnknownError: boolean;

    /*
    The problem is that Javascript's built-in class Error breaks the prototype chain by switching the object to be constructed (i.e. this) to a new,
    different object, when you call super and that new object doesn't have the expected prototype chain, i.e. it's an instance of Error not of GraphQLServerError
     */

    constructor(error: any, url?: string) {
        // 'Error' breaks prototype chain here
        super(error);
        // restore prototype chain
        Object.setPrototypeOf(this, new.target.prototype);

        if (!(error instanceof ApolloError)) {
            return;
        }

        let graphQLErrors: GraphQLErrors = [
            error.graphQLErrors ?? [],
            ((error.networkError as ServerError)?.result?.errors as GraphQLError[]) ?? [],
        ].flatMap(x => x);

        const graphQLError = graphQLErrors[0];

        this.code = graphQLError?.extensions?.code as string;
        this.entityName = graphQLError?.extensions?.EntityName as string;
        this.errorKey = graphQLError?.extensions?.ErrorKey as string;
        this.errorType = graphQLError?.extensions?.ErrorType as string;
        this.objectKey = graphQLError?.extensions?.ObjectKey as number;

        this.isUnknownError =
            this.code !== ApiErrorTypes.ObjectNotFound &&
            this.code !== ApiErrorTypes.UserFriendlyError &&
            this.code !== GraphQLErrorTypes.NotAuthenticated;

        const { response, bodyText } = (error.networkError || {}) as ServerParseError;
        this.message = JSON.stringify(
            {
                message: error.message,
                graphQLErrors,
                url: response?.url || url,
                statusCode: response?.status,
                body: bodyText,
            },
            null,
            2
        );
    }
}
